import { defineMigrations } from '@tldraw/tldraw'

export const Versions = {
  AddUrlProp: 1,
  AddCropProp: 2,
  MakeUrlsValid: 3,
  AddCornerRoundingProp: 4,
  AddStrokeProps: 5,
  AddReplaceableProps: 6,
  AddBackgroundProp: 7,
  AddRemoveBackgroundProp: 8,
  AddLogoProps: 9,
  AddIsEditableProp: 10,
  AddIsAutoUpdatableProp: 11,
} as const

const NoopMigration = {
  up: (shape: any) => shape,
  down: (shape: any) => shape,
}

export const imageShapeMigrations = defineMigrations({
  currentVersion: Versions.AddIsAutoUpdatableProp,
  migrators: {
    [Versions.AddUrlProp]: NoopMigration,
    [Versions.AddCropProp]: NoopMigration,
    [Versions.MakeUrlsValid]: NoopMigration,
    [Versions.AddCornerRoundingProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, cornerRounding: 0 } }
      },
      down: (shape) => {
        const { cornerRounding: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddStrokeProps]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, strokeWidth: 0, strokeColor: '#000000' } }
      },
      down: (shape) => {
        const { strokeWidth: _, strokeColor: __, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddReplaceableProps]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isReplaceable: false, wasReplaced: false } }
      },
      down: (shape) => {
        const { isReplaceable: _, wasReplaced: __, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddBackgroundProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isBackground: false } }
      },
      down: (shape) => {
        const { isBackground: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddRemoveBackgroundProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, removeBackground: null } }
      },
      down: (shape) => {
        const { removeBackground: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddLogoProps]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isLogo: false } }
      },
      down: (shape) => {
        const { isLogo: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddIsEditableProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isEditable: true } }
      },
      down: (shape) => {
        const { isEditable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddIsAutoUpdatableProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isAutoUpdatable: true } }
      },
      down: (shape) => {
        const { isAutoUpdatable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
  },
})
